<template>
  <div
    v-if="visible && event"
    class="timeline-popup"
    :style="popupStyle"
    data-testid="timeline-popup"
    @mouseenter="$emit('popup-enter')"
    @mouseleave="$emit('popup-leave')"
  >
    <div class="timeline-popup__header">
      <span class="timeline-popup__sensor" :title="sensorName">{{ sensorName }}</span>
      <span class="timeline-popup__time">{{ timeLabel }}</span>
      <span class="timeline-popup__count">{{ $t('label.count', { count }) }}</span>
    </div>
    <!-- 映像を持たない検出結果では、サムネイルとアクティビティへの導線を出さない -->
    <template v-if="detailed">
      <div
        class="timeline-popup__thumbnail"
        data-testid="popup-thumbnail"
        @click="$emit('show-gallery')"
      >
        <img
          :src="thumbnailUrl"
          :alt="sensorName"
          class="timeline-popup__thumbnail-img"
          data-testid="popup-thumbnail-img"
        />
        <v-icon class="timeline-popup__play-icon" dark size="36">fa-play-circle</v-icon>
      </div>
      <router-link
        :to="activityLink"
        class="timeline-popup__link"
      >
        {{ $t('link.view_activity') }}
      </router-link>
    </template>
  </div>
</template>

<i18n lang="yaml">
ja:
  label:
    count: '{count} 件'
  link:
    view_activity: 'アクティビティを表示'
en:
  label:
    count: '{count} events'
  link:
    view_activity: 'View Activity'
</i18n>

<script>
export default {
  name: 'timeline-popup',
  inheritAttrs: false,
  props: {
    visible: { type: Boolean, default: false },
    event: { type: Object, default: null },
    sensorName: { type: String, default: '' },
    timeLabel: { type: String, default: '' },
    count: { type: Number, default: 0 },
    position: { type: Object, default: () => ({ top: 0, left: 0 }) },
    width: { type: Number, default: 320 },
    activityLink: { type: Object, default: () => ({}) },
    detailed: { type: Boolean, default: true },
  },
  data() {
    return {
      adjustedLeft: null,
    };
  },
  computed: {
    popupStyle() {
      const left = this.adjustedLeft !== null ? this.adjustedLeft : this.position.left;
      return {
        top: `${this.position.top}px`,
        left: `${left}px`,
        width: `${this.width}px`,
      };
    },
    thumbnailUrl() {
      return this.event?.attachments?.thumbnail || '';
    },
  },
  watch: {
    position() {
      this.adjustedLeft = null;
      this.$nextTick(this.clampPosition);
    },
  },
  methods: {
    clampPosition() {
      if (!this.$el || !this.$el.offsetParent) return;
      const parentRect = this.$el.offsetParent.getBoundingClientRect();
      const elRect = this.$el.getBoundingClientRect();
      if (elRect.right > parentRect.right) {
        this.adjustedLeft = this.position.left - (elRect.right - parentRect.right);
      }
    },
  },
};
</script>

<style scoped>
.timeline-popup {
  position: absolute;
  z-index: 10;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 8px 10px;
}

.timeline-popup__header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 11px;
}

.timeline-popup__sensor {
  max-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
  color: #333;
}

.timeline-popup__time {
  color: #888;
}

.timeline-popup__count {
  color: #888;
  margin-left: auto;
}

.timeline-popup__thumbnail {
  position: relative;
  cursor: pointer;
  margin-bottom: 6px;
}

.timeline-popup__thumbnail-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

.timeline-popup__play-icon {
  position: absolute !important; /* Vuetifyの .v-icon { position: relative } を上書き */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.timeline-popup__link {
  display: block;
  text-align: center;
  font-size: 11px;
}
</style>
